export var menuItems = {
  "data": [
    {
      "path": "/", 
      "title": "Overview",
      "icon": "overview",
      "type": "link",
      "active": true,
      "role": "user"  
    },
    {
      "path": "/",  
      "title": "Overview",
      "icon": "overview",
      "type": "link",
      "active": true,  
      "role": "user"  
    },
    {
      "title": "Payments",
      "icon": "payments",
      "type": "sub",
      "badgeType": "light-primary",
      "badgeValue": "",
      "active": false,
      "role": "user",
      "children": [
        {
          "path": "/transaction",
          "title": "Transactions",
          "type": "link",
          "active": false,
        },
        {
          "path": "/settlements",
          "title": "Settlements",
          "type": "link",
          "active": false,
        },
      ]
    },
    {
      "path": "/reports",
      "title": "Reports",
      "icon": "reports",
      "type": "link",
      "active": false,
      "role": "user"
    },
    {
      "path": "/withdraw-funds",
      "title": "Withdraw funds",
      "icon": "withdraw",
      "type": "link",
      "active": false,
      "role": "user",
      
    },
    {
      "path": "/profile",
      "title": "Profile",
      "icon": "profile",
      "type": "link",
      "active": false,
      "role": "user"
    },
    {
      "path": "/card-payment",
      "title": "Card payment",
      "icon": "card-payment",
      "type": "link",
      "active": false,
      "role": "user",
      "isnew": true
    },
    {
      "path": "/",  
      "title": "Test",
      "type": "link",
      "active": false,  
      "role": "admin"  
    },
    {
      "path": "/admin/home",
      "title": "Home",
      "type": "link",
      "active": false,  
      "role": "admin"  
    },
    {
      "path": "/admin/cash-payments", 
      "title": "Payments & Transfers",
      "type": "link",
      "active": false,  
      "role": "admin"  
    },
    {
      "path": "/admin/dashboard",
      "title": "Dashboard",
      "type": "link",
      "active": false,
      "role": "admin"
    },
    {
      "path": "/admin/transactions",
      "title": "Transactions",
      "type": "link",
      "active": false,
      "role": "admin"
    },
    {
      "path": "/admin/driver-profile",
      "title": "Driver profile",
      "type": "link",
      "active": false,
      "role": "admin"
    },
    {
      "path": "/admin/subgroups",
      "title": "Subgroups",
      "type": "link",
      "active": false,
      "role": "admin"
    },
    {
      "path": "/admin/terminal",
      "title": "Terminal",
      "type": "link",
      "active": false,
      "role": "admin"
    },
    {
      "path": "/admin/terminal-performance",
      "title": "Terminal performance",
      "type": "link",
      "active": false,
      "role": "admin"
    },
    {
      "path": "/admin/fees-charges",
      "title": "Fees & charges",
      "type": "link",
      "active": false,
      "role": "admin"
    },
    {
      "path": "/admin/card",
      "title": "Card",
      "type":"sub",
      "active": true,
      "role":"admin",
      "children": [
        {
          "path": "/admin/card-application",
          "title": "Card application",
          "type": "link",
          "active": false,
        },
        {
          "path": "/admin/card-management",
          "title": "Card management",
          "type": "link",
          "active": false,
        },{
          "path": "/admin/card-performance",
          "title": "Card performance",
          "type": "link",
          "active": false,
        }
    ]
    },
    {
      "path": "/admin/refunds",
      "title": "Refunds",
      "type": "link",
      "active": false,
      "role": "admin"
    },
    {
      "path": "/admin/staff-members",
      "title": "Staff members",
      "type": "link",
      "active": false,
      "role": "admin"
    },
    {
      "path": "/admin/fleet",
      "title": "Fleet",
      "type": "link",
      "active": false,
      "role": "admin"
    },
    {
      "path": "/admin/role",
      "title": "Role",
      "type": "link",
      "active": false,
      "role": "admin"
    }
  ]
}
